export default "__VITE_ASSET__Do7$B$9U__"